import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom'
import { ToastProvider } from '@rb/ui'
import { AuthGuard } from './router/guards'
import { AdminGuard } from './router/guards'
import { PublicLayout } from './layouts/PublicLayout'
import { AppShellLayout } from './layouts/AppShellLayout'
import Landing from './pages/Landing'
import Login from './pages/Login'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import Dashboard from './pages/Dashboard'
import ProjectNew from './pages/ProjectNew'
import ProjectDetail from './pages/ProjectDetail'
import ProjectPart from './pages/ProjectPart'
import ProjectReport from './pages/ProjectReport'
import Settings from './pages/Settings'
import Symon from './pages/Symon'
import AdminProjects from './pages/AdminProjects'
import AdminProjectDetail from './pages/AdminProjectDetail'
import AdminActivity from './pages/AdminActivity'
import AdminUsers from './pages/AdminUsers'
import AdminUserDetail from './pages/AdminUserDetail'
import ConfirmEmail from './pages/ConfirmEmail'
import ConfirmEmailChange from './pages/ConfirmEmailChange'
import DemoEmbed from './pages/DemoEmbed'

const router = createBrowserRouter([
  {
    element: <PublicLayout />,
    children: [
      { path: '/', element: <Landing /> },
      { path: '/login', element: <Login /> },
      { path: '/forgot-password', element: <ForgotPassword /> },
      { path: '/reset-password', element: <ResetPassword /> },
      { path: '/projects/new', element: <ProjectNew /> },
      { path: '/confirm-email', element: <ConfirmEmail /> },
      { path: '/confirm-email-change', element: <ConfirmEmailChange /> },
    ],
  },
  { path: '/projects/:id/report', element: <ProjectReport /> },
  // Public, embeddable analysis demo — no AuthGuard, no API/D1/auth, no AppShell.
  { path: '/demo', element: <DemoEmbed /> },
  {
    element: <AuthGuard />,
    children: [
      {
        element: <AppShellLayout navMode="client" />,
        children: [
          { path: '/dashboard', element: <Dashboard /> },
          { path: '/projects/:id', element: <ProjectDetail /> },
          { path: '/projects/:id/:part', element: <ProjectPart /> },
          { path: '/settings', element: <Settings /> },
          { path: '/symon', element: <Symon /> },
        ],
      },
    ],
  },
  {
    element: <AdminGuard />,
    children: [
      {
        element: <AppShellLayout navMode="admin" />,
        children: [
          { path: '/admin/projects', element: <AdminProjects /> },
          { path: '/admin/projects/:id', element: <AdminProjectDetail /> },
          { path: '/admin/activity', element: <AdminActivity /> },
          { path: '/admin/users', element: <AdminUsers /> },
          { path: '/admin/users/:id', element: <AdminUserDetail /> },
        ],
      },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
])

export default function App() {
  return (
    <ToastProvider>
      <RouterProvider router={router} />
    </ToastProvider>
  )
}
